import { ApiProperty } from '@nestjs/swagger'
import { Review } from './review.dto'

export class Rating {
	@ApiProperty({ type: Number })
	totalRatings: number

	@ApiProperty({ type: Number })
	averageRating: number
}

export class ChartDataPoint {
	@ApiProperty({ type: String })
	label: string

	@ApiProperty({ type: Number, isArray: true })
	data: number[]
}

export class StatisticsResponse {
	@ApiProperty({ type: String, isArray: true })
	topDishes: string[]

	@ApiProperty({ type: Review, isArray: true })
	reviews?: Review[]

	@ApiProperty({ type: Rating })
	ratings?: Rating

	@ApiProperty({ type: ChartDataPoint, isArray: true })
	rushHourData: ChartDataPoint[]

	@ApiProperty({ type: ChartDataPoint, isArray: true })
	customerEventsData: ChartDataPoint[]
}
